import BrandBlue from 'assets/svgs/nightowl-brand-blue.svg';

import './Loader.scss';

export const Loader = () => {
  return (
    <div className="loader">
      <img src={BrandBlue} alt="" />
      <div className="line">
        <div className="inner"></div>
      </div>
    </div>
  );
};
